import { DATE_FORMATS } from "lib/@constants/date-format"
import { getAuditsByReferenceIdAndType } from "routes/audit/controller/get-audits-by-reference-id"

export function useGetChangeTypeAudits(referenceId, changeType, draftId, taskId) {
    if (!taskId && changeType === "task")
        return {
            loading: false,
            auditId: null,
            isExisting: false,
            latestReason: "",
            createdBy: undefined,
            createdDate: undefined,
        }

    const { data, loading } = getAuditsByReferenceIdAndType.useResults.status(referenceId, "customSchedule", {
        "payload.changeType": changeType,
        "payload.idForDraft": draftId,
        "payload.taskId": taskId,
    })
    const isExisting = !!(data && data.length > 0)
    const latestReason = data?.[0]?.payload?.reason ?? ""
    const createdBy = data?.[0]?.userName
    const createdDate = Date.create(data?.[0]?.date).format(DATE_FORMATS.long)
    const auditId = data?.[0]?.id

    return { loading, auditId, isExisting, latestReason, createdBy, createdDate }
}
